import * as amplitude from '@amplitude/analytics-browser';
import PropTypes from 'prop-types';
import { useCallback } from 'react';

import ReactionsManager from 'hb-react/frontoffice/components/Reactions';
import useNavigatorShare from 'hb-react/shared/hooks/useNavigatorShare';
import { getSharedContentType } from 'hb-react/shared/utils/amplitude/getSharedContentType';

const Reactions = ({ file, reactions = {} }) => {
  const {
    initialLikes: likes,
    isLoadingLikes = false,
    onLikeCallback,
    ...restReactions
  } = reactions;

  // Triggers the like event
  const handleLike = useCallback(
    (likes) => {
      if (onLikeCallback) {
        onLikeCallback(likes, file);
      }
    },
    [onLikeCallback, file],
  );

  const shareFileOrPostUrl = file?.sharePostUrl
    ? file?.sharePostUrl
    : `${window.location.origin}${window.location.pathname}`;

  const { handleShare, shareUrl } = useNavigatorShare({
    data: {
      text: file?.name,
      url: shareFileOrPostUrl,
    },
    onShare: () => {
      amplitude.track(
        `Reactions|${getSharedContentType(file.file_type)}}Shared`,
      );
    },
  });

  if (!file || !Object.keys(file).length || isLoadingLikes || !likes) {
    return null;
  }

  return (
    <ReactionsManager
      initialLikes={likes}
      id={file.id}
      key={file.id}
      onLikeCallback={handleLike}
      handleShareButton={handleShare}
      shareUrl={shareUrl}
      sharedContent={file}
      {...restReactions}
    />
  );
};

Reactions.propTypes = {
  file: PropTypes.object,
  reactions: PropTypes.object,
};

export default Reactions;
